<div class="flex-vertical gap-16 width-100pc">
  <div>
    {{ totalCount }} @if (totalCount > 1) {
    <span>types documents</span
      >
      }@if (totalCount < 2) {
      <span>type document</span>
    }
  </div>
  <div class="width-100pc">
    <oui-table>
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="typesDocument">
          <th mat-header-cell *matHeaderCellDef>Type document Box</th>
          <td mat-cell *matCellDef="let element">{{ element?.key }}</td>
        </ng-container>
        <ng-container matColumnDef="parentGedLibelle">
          <th mat-header-cell *matHeaderCellDef>Type GED associé</th>
          <td mat-cell *matCellDef="let element">
            {{ element?.gedTypeDocument?.libelle }}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        @if (!isLoading) {
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        }
      </table>
      @if (isLoading) {
        <oui-loading class="flex-vertical flex-center padding-vertical-16"></oui-loading>
      }
      <oui-paginator
        [pageSizeOptions]="pageSizeOptions"
        [length]="totalCount"
        [pageIndex]="pageIndex"
        [pageSize]="pageSize">
      </oui-paginator>
    </oui-table>
  </div>
</div>
